import { Component, computed, input, InputSignal, model, ModelSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QuestionContentComponent } from 'src/app/faq/components/question/question-content/question-content.component';
import { MostRelevantItemShortComponent } from 'src/app/most-relevant/most-relevant-item-short/most-relevant-item-short.component';
import { IFaq } from 'src/app/shared/interfaces/IFaq';
import { IHelpItem } from 'src/app/shared/interfaces/IHelpItem';
import { SearchResultType } from 'src/app/shared/interfaces/search.interface';
import { CountryCode } from 'src/app/shared/interfaces/IHelpItemCountryAddOn';
import { HeaderSearchLinkComponent } from '../header-search-link/header-search-link.component';

@Component({
  selector: 'app-header-search-item',
  imports: [TranslateModule, QuestionContentComponent, MostRelevantItemShortComponent, HeaderSearchLinkComponent],
  templateUrl: './header-search-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-search-item.component.scss'
})
export class HeaderSearchItemComponent {
  public readonly type: InputSignal<SearchResultType> = input.required<SearchResultType>();
  public readonly item: InputSignal<IHelpItem | IFaq> = input.required<IHelpItem | IFaq>();
  public readonly countryFilter = input<CountryCode[]>([]);
  public readonly isExpanded: ModelSignal<boolean> = model<boolean>(false);

  protected helpItem = computed(() => this.item() as IHelpItem);

  protected addOnCountries: Signal<CountryCode[]> = computed(() =>
    this.countryFilter()?.filter(countryCode => {
      const helpItem = this.helpItem();
      if (!helpItem?.addOns || helpItem?.addOns?.length === 0) {
        return false;
      }

      return helpItem.addOns.some(addOn => addOn.country.toLowerCase() === countryCode.toLowerCase());
    })
  );

  protected toggleExpanded(): void {
    this.isExpanded.set(!this.isExpanded());
  }
}
